<template>
  <v-sheet
    @click="openGame"
    :style="`position: relative; cursor: ${has_started ? 'pointer' : ''};`"
    elevation="3"
  >
    <div class="blinking-indicator" v-if="is_currently_live">
      <v-chip x-small color="red" label style="position: absolute; left: 5px; top: 5px; color: white;">LIVE</v-chip>
    </div>
    <div v-if="!is_currently_live && !has_started">
      <v-chip x-small color="grey" label style="position: absolute; left: 5px; top: 5px; color: white;">Tulossa</v-chip>
    </div>
    <div v-if="game.analyzed" style="position: absolute; bottom: 5px; left: 5px;">
      <v-chip color="primary" x-small label outlined>
        <v-icon size="12" class="mr-2">mdi-check</v-icon>
        Käsitelty
      </v-chip>
    </div>
    <div v-else-if="!game.will_be_analyzed" style="position: absolute; bottom: 5px; left: 5px;">
      <!-- <v-chip color="red" x-small label outlined>
        Ei käsitellä
      </v-chip> -->
    </div>
    <div v-else style="position: absolute; bottom: 5px; left: 5px;">
      <v-chip x-small label outlined>
        Käsitellään
      </v-chip>
    </div>
    <v-sheet class="d-flex justify-space-around px-4 pt-5">
      <v-img
        :src="game.home_club_logo_url"
        height="50"
        width="50"
        contain
      ></v-img>
      <v-img
        :src="game.away_club_logo_url"
        height="50"
        width="50"
        contain
      ></v-img>
    </v-sheet>
    <v-sheet class="d-flex justify-space-around px-4">
      <v-sheet class="text-button">{{game.home_club_short_name}}</v-sheet>
      <v-sheet class="text-button">{{game.away_club_short_name}}</v-sheet>
    </v-sheet>
    <div style="text-align: center; margin-top: -58px;">
      <v-sheet style="height: 30px;">
        <v-sheet
          class="text-button"
          v-if="game.score_home != 0 || game.score_away != 0"
        >
          {{game.score_home}} - {{game.score_away}}
        </v-sheet>
      </v-sheet>
    </div>
    <v-sheet class="mt-6 pb-2 d-flex justify-center">
      <v-chip label outlined small>
        <span v-if="has_started">
          {{ prettyDate }}
        </span>
        <span v-else>
          {{ time_to_start_pretty }}
        </span>
      </v-chip>
    </v-sheet>
    <v-sheet class="d-flex mt-1 mx-auto" style="width: 60%;">
      <v-menu
        open-on-hover
        offset-y
        v-for="state in season.states || []"
        :key="state.id"
        center
      >
        <template v-slot:activator="{on, attrs}">
          <v-sheet
            v-bind="attrs"
            :style="`background-color: ${ state_done(state.id) ? '#4dff52' : 'lightgrey' }`"
            v-on="on"
            class="ma-1"
            style="height: 5px; border-radius: 5px; flex-grow: 1; background-color: grey;"
          ></v-sheet>
        </template>
        <v-card>
          <v-card-text>
            {{ state.state_name }}
          </v-card-text>
        </v-card>
        <!-- {{ state }} -->
      </v-menu>
    </v-sheet>
    <v-menu open-on-hover offset-y v-if="game.game_info">
      <template v-slot:activator="{on, attrs}">
        <v-btn
          :style="`position: absolute; right: 5px; top: ${ game.game_error ? '40' : '5' }px;`"
          v-bind="attrs"
          v-on="on"
          fab
          x-small
          text
        >
          <v-icon color="blue" size="35">
            mdi-information-slab-symbol
          </v-icon>
        </v-btn>
      </template>
      <v-card max-width="200">
        <v-card-text>
          {{ game.game_info }}
        </v-card-text>
      </v-card>
    </v-menu>
    <v-menu open-on-hover offset-y v-if="game.game_error">
      <template v-slot:activator="{on, attrs}">
        <v-btn
          style="position: absolute; right: 5px; top: 5px;"
          v-bind="attrs"
          v-on="on"
          fab
          x-small
          text
        >
          <v-icon color="red">
            mdi-alert-outline
          </v-icon>
        </v-btn>
      </template>
      <v-card max-width="200">
        <v-card-text>
          {{ game.game_error }}
        </v-card-text>
      </v-card>
    </v-menu>
    <!-- {{game}} -->
  </v-sheet>
</template>


<script>
export default {
  props: ['game', 'season'],
  data: () => ({
    game_opens_before: 20 * 60 * 1000, // twenty minutes in milliseconds
    update_interval: null,
    game_key: 0
  }),
  created() {
    this.update_interval = setInterval(() => {
      this.game_key++
    }, 1000 * 30)
  },
  computed: {
    prettyDate() {
      const date = new Date(this.game.starttime_unix)
      return date.getDate() + '.' + (date.getMonth() + 1 )+ '.' + date.getFullYear()
    },
    livePermission() {
      return this.game.shown_live // Add more conditions here
    },
    has_started() {
      this.game_key
      if(!this.livePermission) return this.is_published
      return this.game.starttime_unix - this.game_opens_before < Date.now()
    },
    is_published() {
      this.game_key

      return this.game.publishtime_unix < Date.now()
    },
    is_currently_live() {
      return this.has_started && this.livePermission && this.game.publishtime_unix > Date.now()
    },
    time_to_start() {
      this.game_key

      return Math.max(0, (this.livePermission ? this.game.starttime_unix : this.game.publishtime_unix) - Date.now())
    },
    time_to_start_pretty() {
      const hours = Math.floor(this.time_to_start / 1000 / 60 / 60)
      const minutes = Math.floor(this.time_to_start / 1000 / 60) % 60

      return `${hours}h ${minutes}min`
    }
  },
  methods: {
    state_done(state_id) {
      const state = this.season.states.find(s => s.id == state_id)
      const done_state = this.season.states.find(s => s.id == this.game.done_analysis_state)

      if(!done_state) return false

      if(this.game.done_analysis_state == state_id) return true
      if(state.state_order < done_state.state_order) return true
      return false
    },
    openGame() {
      if(this.has_started ) this.$router.push(`/games/${this.game.id}?from=${this.$route.fullPath}`)
    }
  },
  beforeDestroy() {
    clearInterval(this.update_interval)
  }
}
</script>

<style lang="scss" scoped>
.blinking-indicator {
  animation: blink 1.5s infinite; /* Blinking animation */
}

@keyframes blink {
  0%, 100% {
    opacity: 1; /* Fully visible */
  }
  50% {
    opacity: .2; /* Invisible */
  }
}
</style>